import type { DesktopUpdateState } from '@dob/domain';
import { formatDateTime, formatTime, type Lang } from '@dob/i18n';

import type { useLang } from '../../i18n.ts';

type Translate = ReturnType<typeof useLang>['t'];

/** One sentence for what the updater is doing now (the updates page and the before-work screen). */
export function updateStepText(state: DesktopUpdateState, t: Translate, lang: Lang): string {
  const version = state.release?.version ?? '';
  switch (state.step) {
    case 'not_yet':
      return t('updates.step_not_yet', {
        version,
        time: state.release ? formatDateTime(state.release.availableAt, lang) : '',
      });
    case 'wait_window':
      return t('updates.step_wait_window', { version, time: formatTime(state.window.start) });
    case 'send_first':
      return t('updates.step_send_first', { version, count: state.pending });
    case 'download':
    case 'install':
    case 'installing':
      return t(`updates.step_${state.step}`, { version });
    default:
      return t(`updates.step_${state.step}`);
  }
}
